"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.initialValues = exports.icon = exports.getMetricsPrefix = exports.getMetrics = exports.getDataDefinitions = exports.fields = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var fields = exports.fields = ['image', 'altText'];
var initialValues = exports.initialValues = {
  image: '',
  altText: 'Image'
};
var icon = exports.icon = /*#__PURE__*/_react["default"].createElement("i", {
  className: "glyphicon glyphicon-film"
});
var validate = exports.validate = function validate(values) {
  return {};
};
var getMetricsPrefix = exports.getMetricsPrefix = function getMetricsPrefix() {
  return 'im';
};
var getDataDefinitions = exports.getDataDefinitions = function getDataDefinitions(id, settings) {
  return {};
};
var getMetrics = exports.getMetrics = function getMetrics(id, settings, answer) {
  return {};
};